<template>
  <div class="register-box">
    <v-head :title="title"></v-head>
    <div class="content">
      <person></person>
    </div>


  </div>
</template>

<script>
  import vHead from "@/components/Subhead.vue";
  import person from "../register/meetRegister/person";
  import { Tab, Tabs } from "vant";
  export default {
    data() {
      return {
        title: "账号注册",
        active: 0,
      };
    },
    computed: {
      register() {
        return this.$route.query && this.$route.query.registerType;
      }
    },
    components: {
      vHead,
      person,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
    },
    methods: {

    },
    mounted() {
      if (this.register == 1) {
        this.active = 1
      } else {
        this.active = 0
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/.van-tabs__nav--card {
    margin: 0 6%;
  }

  /deep/.van-tabs__content {
    padding: 10px 6% 30px 6%;
  }


  .content {
    padding: 26px 20px;
  }

  .input-item {
    padding: 0;
    padding-bottom: 12px;
    display: flex;
    align-items: center;

    i {
      color: #aaa;
    }

    &+.input-item {
      margin-top: 20px;
    }
  }
</style>